<script setup lang="ts">
import DOMPurify from 'dompurify';

import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import { useFormatDate } from '@modules/core/composables/datetime';

import type { StaticPagePreviewProps } from './types';

withDefaults(defineProps<StaticPagePreviewProps>(), {
  body: '',
});

const { formatDate } = useFormatDate();
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <VCard v-data-qa-auto-id="'StaticPagePreview'"
    type="form"
  >
    <template
      v-if="!isLoading"
      #title
    >
      <div class="flex gap-4">
        <div>{{ title }}</div>
        <div
          v-if="lastUpdate"
          class="ml-auto flex gap-2 text-base font-normal"
        >
          <span>{{ lastUpdateLabel }}</span>
          <span class="font-medium">{{ formatDate(lastUpdate, 'PPp') }}</span>
        </div>
      </div>
    </template>
    <VLoader
      :loading="isLoading"
      min-height="200px"
    >
      <div>
        <div
          class="text-editor"
          v-html="DOMPurify.sanitize(body)"
        />
        <div
          v-if="backRoute"
          class="mt-8"
        >
          <VBackButton
            :to="backRoute"
            :label="backButtonLabel"
          />
        </div>
      </div>
    </VLoader>
  </VCard>
</template>
